// Policy content for منصة التشاليح. Placeholders {NAME} {ADDR} {CR} {WA} {EMAIL}
// are replaced at render time with live legal data from admin settings.
// No invented fees, durations, tax numbers, licenses, or carriers.

export const POLICY_LIST = [
  ["terms", "الشروط والأحكام"],
  ["privacy", "سياسة الخصوصية"],
  ["returns", "سياسة الاستبدال والاسترجاع"],
  ["refund", "سياسة استرداد الأموال"],
  ["complaints", "سياسة الشكاوى والنزاعات"],
  ["payment", "سياسة الدفع"],
  ["shipping", "سياسة الشحن والتوصيل والاستلام"],
  ["cancellation", "سياسة إلغاء الطلبات"],
  ["acceptable-use", "سياسة الاستخدام المقبول"],
  ["reviews", "سياسة التقييمات والمراجعات"],
  ["listing", "سياسة عرض وبيع قطع الغيار"],
  ["yard-registration", "سياسة تسجيل وتشغيل التشاليح"],
  ["geolocation", "سياسة استخدام الموقع الجغرافي"],
  ["whatsapp", "سياسة التواصل وواتساب"],
];

const P = (text) => ({ type: "p", text });
const L = (items) => ({ type: "list", items });
const H = (text) => ({ type: "h", text });

export const POLICIES = {
  terms: {
    title: "الشروط والأحكام",
    intro: "باستخدامك {NAME} فإنك توافق على هذه الشروط. تُوفّر المنصة بيئة تقنية تجمع التشاليح وبائعي قطع غيار السيارات المستعملة في مكان واحد، وتُسهّل عرض القطع وإدارة الطلبات والتواصل بين العميل والتشليح.",
    sections: [
      H("التعريفات"),
      L([
        "المنصة: {NAME}، العنوان {ADDR}.",
        "العميل: أي مستخدم ينشئ حسابًا للبحث عن القطع وطلبها.",
        "التشليح/البائع: المنشأة التي تعرض وتبيع قطع الغيار عبر حسابها في المنصة.",
      ]),
      H("طبيعة عمل المنصة"),
      P("التشليح هو البائع الفعلي للقطعة، والمنصة وسيط تقني لعرض القطع وإدارة الطلبات والتواصل بين الأطراف، دون المساس بحقوق المستهلك المقررة نظامًا في المملكة العربية السعودية."),
      H("الحسابات"),
      L([
        "ينشئ العميل حسابًا ببريده أو جواله أو عبر Google، ويكون مسؤولًا عن صحة بياناته وسرية دخوله.",
        "يسجّل التشليح باسم منشأته ورقم سجله التجاري الخاص به، ويُمنع استخدام سجل المنصة لأي تشليح.",
        "قد تراجع المنصة بيانات التشليح قبل التفعيل أو عند الحاجة.",
      ]),
      H("مسؤوليات التشليح"),
      L([
        "صحة بيانات المنشأة والسجل التجاري.",
        "صحة اسم القطعة ووصفها وصورها وحالتها وسعرها والعيوب المعروفة إن وجدت.",
        "تجهيز القطعة وتنفيذ الطلب والتواصل مع العميل.",
      ]),
      H("مسؤوليات العميل"),
      P("تقديم بيانات صحيحة، واستخدام المنصة بشكل نظامي، والالتزام بالتعامل اللائق مع التشاليح."),
      H("الطلبات والتواصل"),
      P("يتم إنشاء الطلب من صفحة القطعة، ويمكن التواصل مع التشليح مباشرة، كما يمكن التواصل مع دعم المنصة عبر واتساب {WA}."),
      H("الشكاوى والاسترجاع والنزاعات"),
      P("يحق للعميل تقديم شكوى أو طلب استرجاع/استبدال من داخل الطلب، وتتابع إدارة المنصة النزاعات حتى إغلاقها وفق الأنظمة."),
      H("المحتوى والملكية الفكرية وإساءة الاستخدام"),
      L([
        "يُمنع نشر محتوى مخالف أو مضلل أو انتهاك حقوق الغير.",
        "للمنصة إيقاف أي حساب مخالف واتخاذ الإجراءات المناسبة.",
      ]),
      H("تعديل الشروط والاختصاص القضائي"),
      P("قد تُحدَّث هذه الشروط، ويسري عليها نظام المملكة العربية السعودية وتختص جهاتها القضائية بأي نزاع."),
    ],
  },
  privacy: {
    title: "سياسة الخصوصية",
    intro: "نلتزم في {NAME} بحماية خصوصية مستخدمينا وجمع البيانات الضرورية فقط لتقديم الخدمة.",
    sections: [
      H("البيانات التي قد نجمعها"),
      L([
        "الاسم، رقم الجوال، البريد الإلكتروني، وبيانات الحساب وتسجيل الدخول.",
        "بيانات التشليح والمنشأة ورقم السجل التجاري.",
        "بيانات الطلبات والتواصل.",
        "الموقع الجغرافي عند موافقتك فقط.",
        "بيانات تقنية وملفات Cookies إن استُخدمت.",
      ]),
      H("أسباب جمع البيانات"),
      L([
        "إنشاء الحساب وتقديم الخدمات وتنفيذ الطلبات والتواصل.",
        "تحسين المنصة وحمايتها من الاحتيال ومعالجة الشكاوى.",
        "الالتزام بالمتطلبات النظامية.",
      ]),
      H("حقوقك"),
      P("لك الحقوق المتعلقة ببياناتك الشخصية وفق الأنظمة السعودية ذات العلاقة، وتستطيع التواصل معنا بشأنها عبر دعم المنصة {WA} أو البريد {EMAIL}."),
      H("المشاركة"),
      P("لا نبيع بياناتك ولا نشاركها مع أطراف غير مصرح لها، ونشارك فقط ما يلزم لإتمام الطلب مع التشليح المعني."),
    ],
  },
  returns: {
    title: "سياسة الاستبدال والاسترجاع",
    intro: "نحرص على تجربة عادلة وواضحة. توضح هذه السياسة متى وكيف تطلب الاستبدال أو الاسترجاع، بما يتوافق مع الأنظمة السعودية وحقوق المستهلك.",
    sections: [
      H("متى يمكنك طلب الاستبدال أو الاسترجاع؟"),
      L([
        "إذا وصلتك قطعة مختلفة عن المطلوبة.",
        "إذا كانت القطعة غير مطابقة للوصف أو الصور أو المعلومات المعروضة.",
        "إذا كانت القطعة تالفة أو بها عيب.",
        "إذا كانت مواصفات القطعة مختلفة عمّا تم عرضه أو الاتفاق عليه.",
      ]),
      H("حالات قد لا يُستحق فيها الاسترجاع"),
      P("قد لا يكون الاسترجاع مستحقًا في بعض الحالات وفق الأنظمة (مثل تلف ناتج عن سوء الاستخدام بعد الاستلام)، دون أي مساس بحقوقك المقررة نظامًا. كون القطعة «مستعملة» لا يُسقط حقوقك النظامية تلقائيًا."),
      H("كيف تقدّم الطلب؟"),
      L([
        "افتح الطلب من «طلباتي» ثم اضغط «طلب استرجاع / استبدال».",
        "اختر السبب واشرح المشكلة وأرفق صورًا أو فيديو.",
        "أرسل الطلب لتظهر حالته «قيد المراجعة».",
      ]),
      H("كيف تتم المراجعة؟"),
      P("يصل طلبك إلى التشليح للرد عليه، ويمكن لإدارة المنصة التدخل عند الحاجة ومتابعة النزاع حتى الإغلاق. تستطيع متابعة كل التحديثات من حسابك عبر حالة الطلب."),
      H("التواصل"),
      P("للمساعدة تواصل مع دعم المنصة عبر واتساب {WA}."),
    ],
  },
  refund: {
    title: "سياسة استرداد الأموال",
    intro: "توضح هذه السياسة متى تُسترد الأموال وكيف تُعالج، وترتبط تلقائيًا بحالات الإلغاء والاسترجاع والاستبدال.",
    sections: [
      H("متى تكون مستحقًا للاسترداد؟"),
      L([
        "عند قبول طلب استرجاع مستحق.",
        "عند إلغاء طلب قبل تنفيذه وفق سياسة الإلغاء.",
        "في حالات عدم إتمام البيع لأسباب تخص القطعة أو مطابقتها.",
      ]),
      H("طريقة الاسترداد"),
      P("في المرحلة الحالية طريقة الدفع المتاحة هي الدفع عند الاستلام، وبالتالي يتم التعامل مع المستحقات مباشرة بين العميل والتشليح تحت إشراف المنصة عند وجود نزاع. عند تفعيل الدفع الإلكتروني مستقبلًا سيتكامل الاسترداد مع وسيلة الدفع المستخدمة."),
      H("حالات الدفع الفاشل"),
      P("عند فشل عملية دفع إلكتروني مستقبلًا لا يُنشأ التزام مالي على العميل، ويُعاد أي مبلغ محجوز وفق وسيلة الدفع."),
    ],
  },
  complaints: {
    title: "سياسة الشكاوى والنزاعات",
    intro: "يمكنك تقديم شكوى من داخل الطلب، وتتابع إدارة المنصة الشكوى حتى معالجتها.",
    sections: [
      H("محتوى الشكوى"),
      L([
        "رقم الطلب والقطعة والتشليح.",
        "سبب الشكوى وشرح المشكلة.",
        "الصور والفيديو والمرفقات الداعمة.",
      ]),
      H("آلية المعالجة"),
      P("تُراجع الإدارة الشكوى وتتواصل مع الطرفين وتوثّق القرار وتتابع النزاع حتى الإغلاق."),
      H("دعم المنصة"),
      P("تواصل مع دعم المنصة عبر واتساب {WA} برسالة تتضمن رقم طلبك."),
    ],
  },
  payment: {
    title: "سياسة الدفع",
    intro: "توضح هذه السياسة طرق الدفع المتاحة وآلية تأكيدها. وهي قابلة للتحديث عند إضافة بوابة دفع إلكترونية.",
    sections: [
      H("طريقة الدفع الحالية"),
      P("الدفع عند الاستلام هو الطريقة المتاحة حاليًا، حيث يدفع العميل قيمة القطعة مباشرة للتشليح عند الاستلام. لا تأخذ المنصة أي عمولة على قيمة البيع."),
      H("مستقبلًا"),
      P("عند تفعيل الدفع الإلكتروني ستوضح هذه السياسة طرق الدفع وتأكيد العملية وحالتها وفشل الدفع وإلغائه واسترداد الأموال والإيصالات والفواتير وفق النظام."),
    ],
  },
  shipping: {
    title: "سياسة الشحن والتوصيل والاستلام",
    intro: "تختلف خيارات الاستلام حسب كل تشليح.",
    sections: [
      H("الخيارات المتاحة"),
      L([
        "الاستلام من موقع التشليح.",
        "التوصيل المحلي داخل المدينة (حسب توفّره لدى التشليح).",
        "الشحن إلى مدينة أخرى (حسب توفّره لدى التشليح).",
      ]),
      H("المسؤولية"),
      P("يتحمّل التشليح مسؤولية تجهيز القطعة بشكل سليم. تُحدَّد تفاصيل الشحن والتوصيل من قبل التشليح، ولا تفرض المنصة أسعار شحن أو جهات شحن محددة."),
    ],
  },
  cancellation: {
    title: "سياسة إلغاء الطلبات",
    intro: "توضح متى يمكن إلغاء الطلب وعلاقته بالاسترداد.",
    sections: [
      H("متى يمكن الإلغاء؟"),
      L([
        "يمكن إلغاء الطلب قبل تجهيزه أو شحنه.",
        "بعد التجهيز أو الشحن قد يتعذّر الإلغاء وفق حالة الطلب.",
      ]),
      H("الإلغاء والاسترداد"),
      P("عند إلغاء طلب مدفوع مستقبلًا يُعالَج الاسترداد وفق سياسة استرداد الأموال. لا تتضمن هذه السياسة أي شرط يُلغي حقوقك النظامية."),
    ],
  },
  "acceptable-use": {
    title: "سياسة الاستخدام المقبول",
    intro: "للحفاظ على بيئة آمنة وعادلة للجميع.",
    sections: [
      H("يُمنع"),
      L([
        "الاحتيال وانتحال الشخصية والبيانات المزيفة والإعلانات المضللة.",
        "عرض قطع غير نظامية أو إخفاء العيوب المعروفة.",
        "محاولة اختراق النظام أو رفع ملفات ضارة أو التلاعب بالطلبات أو التقييمات.",
        "إساءة استخدام خدمة واتساب أو المنصة.",
      ]),
      H("الإجراءات"),
      P("يحق للإدارة اتخاذ الإجراءات المناسبة تجاه الحسابات المخالفة وفق الأنظمة والشروط."),
    ],
  },
  reviews: {
    title: "سياسة التقييمات والمراجعات",
    intro: "التقييمات تعكس تجارب حقيقية وتساعد بقية العملاء.",
    sections: [
      H("الضوابط"),
      L([
        "يُسمح بالتقييم بعد تجربة حقيقية مع التشليح.",
        "يُمنع التقييم الوهمي أو شراء التقييمات أو التلاعب بها.",
        "يُمنع الإساءة أو التهديد أو التشهير أو نشر بيانات شخصية.",
      ]),
      H("الإشراف"),
      P("يحق للمنصة إزالة أي محتوى مخالف."),
    ],
  },
  listing: {
    title: "سياسة عرض وبيع قطع الغيار",
    intro: "لضمان الوضوح والمصداقية، يلتزم التشليح بتقديم بيانات صحيحة عن كل قطعة.",
    sections: [
      H("بيانات القطعة المطلوبة"),
      L([
        "صور حقيقية للقطعة.",
        "اسم القطعة ونوع السيارة والشركة والموديل والسنة.",
        "حالة القطعة والوصف والعيوب إن وجدت.",
        "السعر ورقم القطعة إذا توفر.",
      ]),
      H("الالتزام"),
      P("يُمنع عرض معلومات مضللة أو إخفاء العيوب المعروفة."),
    ],
  },
  "yard-registration": {
    title: "سياسة تسجيل وتشغيل التشاليح",
    intro: "لكل تشليح حساب ومتجر مستقل، وبيانات خاصة به.",
    sections: [
      H("بيانات التسجيل المطلوبة"),
      L([
        "اسم المنشأة.",
        "رقم السجل التجاري الخاص بالتشليح.",
        "رقم الجوال والبريد الإلكتروني.",
        "المدينة والعنوان والموقع على الخريطة.",
      ]),
      H("المراجعة والتفعيل"),
      P("يمكن للمنصة مراجعة بيانات التشليح قبل تفعيل الحساب أو عند الحاجة، ويظهر توثيق «تشليح موثق» بعد الموافقة."),
    ],
  },
  geolocation: {
    title: "سياسة استخدام الموقع الجغرافي",
    intro: "نستخدم الموقع بموافقتك لتحسين تجربتك فقط.",
    sections: [
      H("الإذن"),
      P("نطلب إذنك بوضوح قبل استخدام موقعك، وإذا رفضت فلن نمنعك من استخدام المنصة، ويمكنك اختيار مدينتك يدويًا."),
      H("استخدامات الموقع"),
      L([
        "معرفة أقرب التشاليح.",
        "حساب المسافة وترتيب النتائج.",
        "عرض الاتجاهات إلى التشليح.",
      ]),
      H("عدم إساءة الاستخدام"),
      P("لا نستخدم الموقع لأي أغراض غير معلنة."),
    ],
  },
  whatsapp: {
    title: "سياسة التواصل وواتساب",
    intro: "نفصل بوضوح بين التواصل مع التشليح والتواصل مع إدارة المنصة.",
    sections: [
      H("تواصل مع التشليح"),
      P("زر «تواصل مع التشليح» يوصلك مباشرة بالبائع عبر رقمه الخاص للاستفسار عن القطعة والطلب."),
      H("دعم واتساب"),
      P("زر «دعم واتساب» يوصلك بإدارة المنصة على الرقم {WA} برسالة: «مرحبًا، أحتاج مساعدة من دعم منصة التشاليح.» هذا الرقم خاص بإدارة المنصة وليس أرقام التشاليح."),
    ],
  },
};

export function fillLegal(text, s) {
  if (!text) return text;
  return text
    .replaceAll("{NAME}", s.platform_name || "منصة التشاليح")
    .replaceAll("{ADDR}", s.address || "")
    .replaceAll("{CR}", "")
    .replaceAll("{WA}", s.support_whatsapp || "")
    .replaceAll("{EMAIL}", s.support_email || "");
}
